import React from 'react'
import { isUrlExternal, Link } from '../../../../../../utils/link'
import { linkListBlockNestedClasses, linkListBlockNestedGridClasses } from '../../../../../../utils/style'
import { getClassName } from '../../../../../../utils/utils'
import { useInView } from '../../../../../hooks/useInView'
import { GridLinkItemLayout } from '../../../../../sharedLayout/gridItem'
import { LinkBlockNested, LinkBlockNestedItem, SVGIconOptions } from '../../../blocksState'

export type LinkBlockNestedStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  contentClassName: string
  listClassName: string
  itemClassName: string
  itemInnerClassName: string
  itemWithLinkClassName: string
  itemWithoutLinkClassName: string
  linkLabelClassName: string
  linkTextClassName: string
  readMoreLabelClassName: string
  linkIconClassName: string
  iconExternalId: string
  iconInternalId: string
}>

export const LinkBlockNestedLayout = (props: LinkBlockNested) => {
  const { inview, index, items, SVGIcon } = props
  const classes = linkListBlockNestedClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("LinkBlockNestedLayout inView:", inview),
    !inview?.triggerOnce
  )

  // TODO: Check if inview works
  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(classes, 'innerClassName', 'py-5')}>
        {items && items.count() > 0 && (
          <div className={getClassName(classes, 'contentClassName', '')}>
            <ul className={getClassName(classes, 'listClassName', 'list-unstyled mb-0 row')}>
              {items.map((item) =>
                item.url ? (
                  <li
                    key={`link-${index}-${item.title}`}
                    className={getClassName(classes, 'itemClassName', 'col-md-6')}
                  >
                    <Link
                      url={item.url}
                      title={item.title}
                      className={getClassName(
                        classes,
                        'itemWithLinkClassName',
                        'btn btn-link w-100 text-left border-bottom rounded-0 pl-0'
                      )}
                    >
                      <LinkItemInner {...item} SVGIcon={SVGIcon} />
                    </Link>
                  </li>
                ) : (
                  <li
                    key={`link-${index}-${item.title}`}
                    className={getClassName(classes, 'itemClassName', 'col-md-6')}
                  >
                    <div
                      className={getClassName(
                        classes,
                        'itemWithoutLinkClassName',
                        'btn btn-link w-100 text-left border-bottom rounded-0 pl-0'
                      )}
                    >
                      <LinkItemInner {...item} SVGIcon={SVGIcon} />
                    </div>
                  </li>
                )
              )}
            </ul>
          </div>
        )}
      </div>
    </section>
  )
}

const LinkItemInner = (p: LinkBlockNestedItem & { SVGIcon?: SVGIconOptions }) => (
  <>
    {p.title && <p className={getClassName(linkListBlockNestedClasses, 'linkLabelClassName', 'm-0')}>{p.title}</p>}
    {p.text && <p className={getClassName(linkListBlockNestedClasses, 'linkTextClassName', 'small m-0')}>{p.text}</p>}
    {p.SVGIcon && (
      <svg
        className={getClassName(linkListBlockNestedClasses, 'linkIconClassName', '')}
        aria-hidden="true"
        width={p.SVGIcon.width ? p.SVGIcon.width : '24px'}
        height={p.SVGIcon.height ? p.SVGIcon.height : '24px'}
      >
        <use
          xlinkHref={`${isUrlExternal(p.url)
            ? getClassName(linkListBlockNestedClasses, 'iconExternalId', '#icon--external')
            : getClassName(linkListBlockNestedClasses, 'iconInternalId', '#icon--chevron-right-large')
            }`}
        />
      </svg>
    )}
  </>
)

export const LinkBlockNestedGridLayout = (props: LinkBlockNested) => {
  const { inview, index, items, SVGIcon } = props
  const classes = linkListBlockNestedGridClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("LinkBlockNestedGridLayout inView:", inview),
    !inview?.triggerOnce
  )

  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(classes, 'innerClassName', 'py-5')}>
        {items && items.count() > 0 && (
          <div className={getClassName(classes, 'contentClassName', '')}>
            <ul className={getClassName(classes, 'listClassName', 'list-unstyled mb-0 row')}>
              {items.map((item) => (
                <li
                  key={`link-${index}-${item.title}`}
                  className={getClassName(classes, 'itemClassName', 'col-md-6')}
                >
                  <GridLinkItemLayout title={item.title} intro={item.text ? item.text : ''} url={item.url} />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </section>
  )
}
